import React, { useState, useEffect } from "react";
import Drawer from "@mui/material/Drawer";
import { TextField, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { ApprovalStatuses, DeliverableStatus, ProjectDeliverableStatus } from "../../constants/Status";
import { AcceptFileType, Action } from "../../constants/Common";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateDeliverableStatus } from "../../api/casp/deliverable";
import { Spinner } from "reactstrap";
// import AttachFile from '@material-ui/icons/AttachFile';
import { DocumentModule, Modules } from "../../constants/Module";
import { deleteDocument, documentList, documentListForProject, getDownloadableLink, uploadFile } from "../../api/casp/document";
import Loader from "../Common/Loader";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
// import { makeStyles } from "@material-ui/core";
import DocumentFilePreviewModal from "../casp/common/DocumentFilePreviewModal";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { getUrl } from "../../helpers/file_helper";
import SweetAlert from "react-bootstrap-sweetalert";
import { withTranslation, useTranslation } from "react-i18next";
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import { AttachFile } from "@mui/icons-material";
import { middleTruncate } from "../../helpers/string_helper";
import { ClearIcon } from "@mui/x-date-pickers";
import DoneIcon from "@mui/icons-material/Done";
import { Role } from "../../constants/Role";
import { useSelector } from "react-redux";



const useStyles = makeStyles({
  blueIcon: {
    color: '#296ced',
    cursor: 'pointer'
  },
});

const SubmitDeliverableDrawer = ({
  isOpen,
  handleClose,
  selectedRow,
  refresh,
  isDisabled,
  action,
  // projectDetails,
  source = '',
  handleStatusChange,
  rowId,
  actionType,
  projectIdForApproval,
  moduleIdforApproval,
  fetchDeliverableDetails,
  row,
  handleApproval,
  status
}) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] =
    useState(false);
  const [disabled, setDisabled] = useState(false);
  const [trigger, setTrigger] = useState(new Date())
  const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
  const [documentId, setDocumentId] = useState();
  const [deliverableObject, setDeliverableObject] = useState({
    name: selectedRow?.deliverable.name ?? "",
    startDate: selectedRow?.deliverable?.PortfolioDeliverable[0]?.startDate ? selectedRow?.deliverable?.PortfolioDeliverable[0]?.startDate : selectedRow?.deliverable.startDate,
    endDate: selectedRow?.deliverable?.PortfolioDeliverable[0]?.endDate? selectedRow?.deliverable?.PortfolioDeliverable[0]?.endDate : selectedRow?.deliverable.endDate,
    description: selectedRow?.description ?? "",
  });
  const [filePath, setFilePath] = useState('');
  const [fileName, setFileName] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [deletingFileType, setDeletingFileType] = useState('');
  const [mvpTestingFiles, setMvpTestingFiles] = useState([]);
  const [dealRoomFiles, setDealRoomFiles] = useState([]);
  const [modal, setModal] = useState(false);
  const classes = useStyles();
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [mvpLoading, setMvpLoading] = useState(false)
  const [dealRoomLoading, setDealRoomLoading] = useState(false)
  const [buttonLoading, setButtonLoading] = useState(false);
  const [deliverableId, setDeliverableId] = useState(moduleIdforApproval)
  const [approvedButtonLoading, setApprovedButtonLoading] = useState(false);
  const [rejectButtonLoading, setRejectButtonLoading] = useState(false);
  const loggedInUser = useSelector((state) => state.Profile.user);
  const deliverableValidation = Yup.object().shape({
    description: Yup.string()
      .max(2000, t("Description can not be greater than 2000 characters"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .required(t("Please enter Description")),
    attachmentId: Yup.array()
      .of(Yup.number())
      // .min(1, t('Select at least one document'))
      .nullable(),
    mvpTesting: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .nullable(),
    dealroomReg: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .nullable(),
    mvpTestingattachmentId: Yup.array()
      .of(Yup.number())
      .nullable(),
    dealRoomAttachmentId: Yup.array()
      .of(Yup.number())
      .nullable(),
    comment: Yup.string()
      .max(2000, t("Comment can not be greater than 2000 characters"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
  });

  console.log('moduleId from component', moduleIdforApproval)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...deliverableObject,
      attachmentId: "",
      mvpTesting: selectedRow?.mvpTesting ?? "",
      dealroomReg: selectedRow?.dealRoomReg ?? "",
      mvpTestingattachmentId: "",
      dealRoomAttachmentId: "",
      comment: selectedRow?.approval?.comments ?? ""
    },
    validationSchema: deliverableValidation,
    validateOnMount: true,
    // onSubmit: (values) => {
    //   handleUpdate();
    // }
  });
  console.log('selectedRow', selectedRow)

  useEffect(() => {
    if (selectedRow && action !== Action.EDIT) {
      getDocumentList()
      if (
        ![DeliverableStatus.DRAFT, DeliverableStatus.REJECTED].includes(
          selectedRow.currentStatus
        ) ||
        isDisabled || action === Action.VIEW || action === Action.APPROVE
      ) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRow]);

  const handleFileUpload = async (key, files) => {
    const loaders = {
      'Non Legal': setLoadingDocument,
      'MVP Testing': setMvpLoading,
      'DealRoom Registration': setDealRoomLoading,
    };

    const formikFields = {
      'Non Legal': 'attachmentId',
      'MVP Testing': 'mvpTestingattachmentId',
      'DealRoom Registration': 'dealRoomAttachmentId'
    };

    const validFiles = Array.from(files).filter((file) => {
      const fileExtension = `.${file.name.split('.').pop().toLowerCase()}`;
      if (!AcceptFileType.includes(fileExtension)) {
        toast.error(`"${file.name}" has invalid file type`);
        return false;
      }
      if (file.size > 10 * 1024 * 1024) {
        toast.error("Please upload file size less than 10 MB");
        return false;
      }
      return true;
    });

    if (validFiles.length === 0) return;

    const setLoader = loaders[key];
    setLoader(true);

    try {
      const formData = new FormData();
      validFiles.forEach(file => {
        formData.append('files', file);
      });

      formData.append('moduleId', selectedRow.id);
      formData.append('module', DocumentModule.PROJECT_DELIVERABLE);
      formData.append('projectId', selectedRow.projectId);
      formData.append('documentType', key);

      const result = (await uploadFile(formData)).data.data;

      formik.setFieldValue(formikFields[key], [result.id]);
      formik.setFieldTouched(formikFields[key], true);

      setTrigger(new Date());
      getDocumentList();
    } catch (error) {
      toast.error(error.message || 'Error uploading files');
    } finally {
      setLoadingDocument(false)
      setMvpLoading(false)
    }
  }

  const handleLinkDownload = async (documentId) => {
    try {
      const result = await getDownloadableLink(documentId);
      if (result.statusCode === 200) {
        toast.success(result.data.message);
        window.open(result.data.data, '_blank');
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      console.error('Error downloading document:', error);
    }
  };

  const getDocumentList = async () => {
    try {
      setLoadingDocument(true)
      setMvpLoading(true)

      let params = {
        projectId: source === 'ActionList' ? selectedRow.project.id : selectedRow.projectId,
        filterFields: ['documentAssociations'],
        filterInputs: '',
        module: Modules.PROJECT_DELIVERABLE,
        moduleId: source = selectedRow.id
      };
      const documentData = await documentListForProject(params)
      const documentDataList = documentData.data.data;

      const filesByType = {
        'Non Legal': [],
        'MVP Testing': [],
        'DealRoom Registration': [],
      };

      documentDataList.forEach(doc => {
        const type = doc.documentType.name;
        if (filesByType[type]) {
          filesByType[type].push(doc);
        }
      });

      setSelectedFiles(filesByType['Non Legal']);
      formik.setFieldValue('attachmentId', filesByType['Non Legal'].map(f => f.id));

      setMvpTestingFiles(filesByType['MVP Testing']);
      formik.setFieldValue('mvpTestingattachmentId', filesByType['MVP Testing'].map(f => f.id));

      setDealRoomFiles(filesByType['DealRoom Registration']);
      formik.setFieldValue('dealRoomAttachmentId', filesByType['DealRoom Registration'].map(f => f.id));
    } catch (err) {
      console.log(err)
    }
    finally {
      setLoadingDocument(false)
      setMvpLoading(false)
      setDealRoomLoading(false)
    }
  }

  const handelDeleteAttachment = async () => {
    const loaderMap = {
      'Non Legal': setLoadingDocument,
      'MVP Testing': setMvpLoading,
      'DealRoom Registration': setDealRoomLoading,
    };
    try {
      setIsOpenSweetAlert(false)
      const loaderSetter = loaderMap[deletingFileType];
      loaderSetter?.(true);

      const res = await deleteDocument(documentId)
      toast.success(res.data.message)
      // Update formik state to reflect deleted attachment

      let updatedFiles = [];
      switch (deletingFileType) {
        case 'Non Legal':
          updatedFiles = selectedFiles.filter(file => file.id !== documentId);
          setSelectedFiles(updatedFiles);
          formik.setFieldValue('attachmentId', updatedFiles.map(f => f.id));
          formik.setFieldTouched('attachmentId', true);
          break;
        case 'MVP Testing':
          updatedFiles = mvpTestingFiles.filter(file => file.id !== documentId);
          setMvpTestingFiles(updatedFiles);
          formik.setFieldValue('mvpTestingattachmentId', updatedFiles.map(f => f.id));
          formik.setFieldTouched('mvpTestingattachmentId', true);
          break;
        case 'DealRoom Registration':
          updatedFiles = dealRoomFiles.filter(file => file.id !== documentId);
          setDealRoomFiles(updatedFiles);
          formik.setFieldValue('dealRoomAttachmentId', updatedFiles.map(f => f.id));
          formik.setFieldTouched('dealRoomAttachmentId', true);
          break;
        default:
          break;
      }

      await formik.validateForm();
      getDocumentList()
      setDocumentId(null);
      setDeletingFileType('');
      loaderSetter?.(false);
    } catch (err) {
      loaderMap[deletingFileType]?.(false);
      setDocumentId(null);
      setDeletingFileType('');
      toast.error(err.message)
    }
  }

  const deliverableSubmit = async () => {
    try {
      const isValid = await formik.validateForm();
      if (Object.keys(isValid).length !== 0) {
        formik.setTouched({
          description: true,
          attachmentId: true,
          mvpTesting: true,
          mvpTestingattachmentId: true,
          dealroomReg: true,
          dealRoomAttachmentId: true
        });
        return toast.error("Please fix the validation errors.");
      }
      setIsLoading(true);

      const normalizeToArray = (value) => {
        if (Array.isArray(value)) return value;
        if (value === null || value === undefined) return [];
        return [value];
      };
      const payload = {
        ...formik.values,
        status: ProjectDeliverableStatus.APPROVED,
        projectId: parseInt(selectedRow.projectId),
        deliverableId: parseInt(selectedRow.deliverable.id),
        attachmentId: normalizeToArray(formik.values.attachmentId),
        mvpTestingattachmentId: normalizeToArray(formik.values.mvpTestingattachmentId),
        dealRoomAttachmentId: normalizeToArray(formik.values.dealRoomAttachmentId),
      }
      delete payload.comment
      const res = await updateDeliverableStatus(payload);
      if (res.statusCode === 200) {
        toast.success(res.data.message);
        refresh()
      } else {
        toast.error(res.message);
      }
      handleClose();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(error.message);
    }
  };

  const deliverableReject = async () => {
    try {
      if (!formik.values.comment) {
        return toast.error("Please enter the comment!");
      }
      const isValid = await formik.validateForm();
      if (Object.keys(isValid).length !== 0) {
        formik.setTouched({
          comment: true
        });
        return toast.error("Please fix the validation errors.");
      }
      setIsLoading(true);
      
      handleApproval(ApprovalStatuses.REJECTED, formik.values.comment, deliverableId, "Projectdeliverable", projectIdForApproval, rowId)
      formik.resetForm({
        values: {
          comment: "",
        }
      });
    } catch (error) {
      setIsLoading(false);
      toast.error(error.message);
    }
  }

  return (
    <>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={handleClose}
        className="projectListDrawer"
        PaperProps={{
          sx: { width: "580px" },
        }}
      >
        <form className="editMilestoneDrawer p-3">
          <h5>{t("Deliverable")}</h5>
          <CloseIcon className="crossIcon" onClick={handleClose} />
          <div className="innerTbContent">
            <div className="row">
              {/* Name */}
              <div className="col-sm-12 mb-3">
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label={t("Name")}
                  name="name"
                  value={formik.values.name}
                  inputProps={{
                    readOnly: isLoading || disabled,
                  }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  required
                />
                {formik.touched.name && formik.errors.name && (
                  <span className="text-danger">{formik.errors.name}</span>
                )}
              </div>

              {/* Start Date */}
              <div className="col-sm-6 mb-3 plDatepicker">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    {deliverableObject.startDate && (
                      <DatePicker
                        label={t("Start Date") + " *"}
                        name="startDate"
                        format="MM/DD/YYYY"
                        value={
                          formik?.values?.startDate?.toString().trim()
                            ? dayjs(formik.values.startDate)
                            : null
                        }
                        on
                        slotProps={{
                          field: {
                            clearable: true, onBlur: (_) => {
                              if (!formik.touched?.startDate) {
                                formik.setFieldTouched("startDate", true, false);
                              }
                            }
                          },
                          onClear: () => {
                            formik.setFieldValue("startDate", '');
                          },
                        }}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "startDate",
                            e ? dayjs(e).format("YYYY-MM-DD") : ''
                          );
                          if (!formik.touched?.startDate) {
                            formik.setFieldTouched("startDate", true, false);
                          }
                        }}
                        readOnly={
                          isLoading || disabled

                        }
                        required
                      />
                    )}
                  </DemoContainer>
                </LocalizationProvider>
                {formik.touched.startDate &&
                  formik.errors.startDate && (
                    <span className="text-danger">
                      {formik.errors.startDate}
                    </span>
                  )}
              </div>

              {/* End Date */}
              <div className="col-sm-6 mb-3 plDatepicker">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    {deliverableObject.endDate && (
                      <DatePicker
                        label={t("End Date") + " *"}
                        name="endDate"
                        format="MM/DD/YYYY"
                        value={
                          formik?.values?.endDate?.toString().trim()
                            ? dayjs(formik.values.endDate)
                            : null
                        }
                        slotProps={{
                          field: {
                            clearable: true, onBlur: (_) => {
                              if (!formik.touched?.endDate) {
                                formik.setFieldTouched("endDate", true, false);
                              }
                            }
                          },
                          onClear: () => {
                            formik.setFieldValue("endDate", '');
                          },
                        }}
                        onChange={(e) => {
                          formik.setFieldValue(
                            "endDate",
                            e ? dayjs(e).format("YYYY-MM-DD") : ''
                          );
                          if (!formik.touched?.endDate) {
                            formik.setFieldTouched("endDate", true, false);
                          }
                        }}
                        readOnly={
                          isLoading || disabled
                        }
                        required
                      />
                    )}
                  </DemoContainer>
                </LocalizationProvider>
                {formik.touched.endDate &&
                  formik.errors.endDate && (
                    <span className="text-danger">
                      {formik.errors.endDate}
                    </span>
                  )}
              </div>

              {/* Description */}
              <div className="col-sm-12 mb-3">
                {/* {((action === Action.VIEW && deliverableObject.description !== "") || (action !== Action.VIEW) ? */}
                <>
                  <TextField
                    fullWidth
                    className="form-control"
                    id="deliverable-title-input"
                    label={t("Description")}
                    name="description"
                    value={formik.values.description}
                    // inputProps={{
                    //   readOnly: isLoading || disabled,
                    // }}
                    disabled={action === Action.VIEW || action === Action.APPROVE || action === Action.APPROVE_REJECT_SHOW}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    multiline
                    required
                    rows={2}
                  />
                  {formik.touched.description && formik.errors.description && (
                    <span className="text-danger">{formik.errors.description}</span>
                  )}
                </>
                {/* : <></>)} */}
              </div>

              {selectedRow?.deliverable?.deliverableOrder === 4 &&
                <>
                  <div className="col-sm-12 mb-3 mt-3">
                    <>
                      <TextField
                        onWheel={(e) => e.target.blur()}
                        fullWidth
                        id="mvpTesting"
                        label={t("MVP Testing")}
                        name="mvpTesting"
                        value={formik.values.mvpTesting}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        type="text"
                        disabled={action === Action.VIEW || action === Action.APPROVE || action === Action.APPROVE_REJECT_SHOW}
                      />
                      {formik.touched.mvpTesting && formik.errors.mvpTesting && (
                        <span className="text-danger">{formik.errors.mvpTesting}</span>
                      )}
                    </>

                    <>
                      <div className="col-sm-12 mb-3">
                        {action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW && (
                          <div className="uploaded_file">
                            <div key={trigger} className="p-3 mx-2 d-flex align-items-center position-relative">
                              <AttachFile
                                className="attachment_button"
                                style={{ cursor: 'pointer' }}
                              />
                              <span className="mx-2">{t("Attach MVP Testing Documents")}
                                {/* {selectedFiles.length === 0 && (
                            <span style={{ color: 'red' }}>*</span>
                          )} */}
                              </span>
                              <input
                                key={trigger}
                                type="file"
                                multiple
                                accept={AcceptFileType.toString()}
                                name="documents"
                                onChange={(e) => handleFileUpload('MVP Testing', e.target.files)}
                                onBlur={() => {
                                  if (!formik.touched?.documents) {
                                    formik.setFieldTouched("documents", true, false);
                                  }
                                }}
                                style={{
                                  opacity: 0,
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  height: "100%",
                                  width: "100%",
                                  cursor: "pointer",
                                }}
                              />
                            </div>
                          </div>
                        )}
                        {!mvpLoading && mvpTestingFiles.length > 0 && (
                          <h5 className="mb-0 mt-2">{t("Attached MVP Testing Documents")}:</h5>
                        )}
                      </div>

                      <div className="mx-3">
                        {formik.touched.mvpTestingattachmentId && formik.errors.mvpTestingattachmentId && (
                          <span className="text-danger">{formik.errors.mvpTestingattachmentId}</span>
                        )}
                      </div>

                      <div>
                        {mvpLoading && <Loader />}
                        {!mvpLoading && mvpTestingFiles.length > 0 && mvpTestingFiles.map((file, key) => (
                          <div className='d-flex mt-1 justify-content-between' key={key}>
                            <span className='fw-semibold text-truncate' title={file.name}>{middleTruncate(file.name)}</span>
                            <div className="actions">
                              <RemoveRedEyeOutlinedIcon
                                className={classes.blueIcon}
                                onClick={() => {
                                  setModal(true);
                                  setFilePath(getUrl(file.storageLink));
                                  setFileName(middleTruncate(file.name));
                                }}
                              />
                              <DownloadIcon className={classes.blueIcon} onClick={() => {
                                handleLinkDownload(file.id)
                              }} />
                              {action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW && (
                                <DeleteOutlineOutlinedIcon
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => {
                                    setDocumentId(file.id);
                                    setIsOpenSweetAlert(true);
                                  }}
                                />
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  </div>
                  {/* <div className="col-sm-12 mb-3 mt-3">
                  <>
                    <TextField
                      onWheel={(e) => e.target.blur()}
                      fullWidth
                      id="dealroomReg"
                      label={t("DealRoom Registration")}
                      name="dealroomReg"
                      value={formik.values.dealroomReg}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      disabled={action === Action.VIEW || action === Action.APPROVE}
                    />
                    {formik.touched.dealroomReg && formik.errors.dealroomReg && (
                      <span className="text-danger">{formik.errors.dealroomReg}</span>
                    )}
                  </>

                  <>
                    <div className="col-sm-12 mb-3">
                      {action !== Action.VIEW && action !== Action.APPROVE &&(
                        <div className="uploaded_file">
                          <div key={trigger} className="p-3 mx-2 d-flex align-items-center position-relative">
                            <AttachFile
                              className="attachment_button"
                              style={{ cursor: 'pointer' }}
                            />
                            <span className="mx-2">{t("Attach DealRoom Registration Documents")} */}
                  {/* {selectedFiles.length === 0 && (
                              <span style={{ color: 'red' }}>*</span>
                            )} */}
                  {/* </span>
                            <input
                              key={trigger}
                              type="file"
                              multiple
                              accept={AcceptFileType.toString()}
                              name="documents"
                              onChange={(e) => handleFileUpload('DealRoom Registration',e.target.files)}
                              onBlur={() => {
                                if (!formik.touched?.documents) {
                                  formik.setFieldTouched("documents", true, false);
                                }
                              }}
                              style={{
                                opacity: 0,
                                position: "absolute",
                                top: 0,
                                left: 0,
                                height: "100%",
                                width: "100%",
                                cursor: "pointer",
                              }}
                            />
                          </div>
                        </div>
                      )}
                      {!dealRoomLoading && dealRoomFiles.length > 0 && (
                        <h5 className="mb-0 mt-2">{t("Attached DealRoom Registration Documents")}:</h5>
                      )}
                    </div>

                    <div className="mx-3">
                      {formik.touched.dealRoomAttachmentId && formik.errors.dealRoomAttachmentId && (
                        <span className="text-danger">{formik.errors.dealRoomAttachmentId}</span>
                      )}
                    </div>

                    <div>
                      {dealRoomLoading && <Loader />}
                      {!dealRoomLoading && dealRoomFiles.length > 0 && dealRoomFiles.map((file, key) => (
                        <div className='d-flex mt-1 justify-content-between' key={key}>
                          <span className='fw-semibold text-truncate' title={file.name}>{middleTruncate(file.name)}</span>
                          <div className="actions">
                            <RemoveRedEyeOutlinedIcon
                              className={classes.blueIcon}
                              onClick={() => {
                                setModal(true);
                                setFilePath(getUrl(file.storageLink));
                                setFileName(middleTruncate(file.name));
                              }}
                            />
                            <DownloadIcon className={classes.blueIcon} onClick={() => {
                              handleLinkDownload(file.id)
                            }} />
                            {action !== Action.VIEW && action !== Action.APPROVE &&(
                              <DeleteOutlineOutlinedIcon
                                style={{ cursor: 'pointer' }}
                                onClick={() => {
                                  setDocumentId(file.id);
                                  setIsOpenSweetAlert(true);
                                }}
                              />
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </>
                </div> */}
                </>
              }

              {/* Attachment */}
              {
                <>
                  <div className="col-sm-12 mb-3">
                    {action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW && (
                      <div className="uploaded_file">
                        <div key={trigger} className="p-3 mx-2 d-flex align-items-center position-relative">
                          <AttachFile
                            className="attachment_button"
                            style={{ cursor: 'pointer' }}
                          />
                          <span className="mx-2">{t("Attach Document")}
                            {/* {selectedFiles.length === 0 && (
                            <span style={{ color: 'red' }}>*</span>
                          )} */}
                          </span>
                          <input
                            key={trigger}
                            type="file"
                            multiple
                            accept={AcceptFileType.toString()}
                            name="documents"
                            onChange={(e) => handleFileUpload('Non Legal', e.target.files)}
                            onBlur={() => {
                              if (!formik.touched?.documents) {
                                formik.setFieldTouched("documents", true, false);
                              }
                            }}
                            style={{
                              opacity: 0,
                              position: "absolute",
                              top: 0,
                              left: 0,
                              height: "100%",
                              width: "100%",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                      </div>
                    )}
                    {!loadingDocument && selectedFiles.length > 0 && (
                      <h5 className="mb-0 mt-2">{t("Attached Documents")}:</h5>
                    )}
                  </div>

                  <div className="mx-3">
                    {formik.touched.attachmentId && formik.errors.attachmentId && (
                      <span className="text-danger">{formik.errors.attachmentId}</span>
                    )}
                  </div>

                  <div>
                    {loadingDocument && <Loader />}
                    {!loadingDocument && selectedFiles.length > 0 && selectedFiles.map((file, key) => (
                      <div className='d-flex mt-1 justify-content-between' key={key}>
                        <span className='fw-semibold text-truncate' title={file.name}>{middleTruncate(file.name)}</span>
                        <div className="actions">
                          <RemoveRedEyeOutlinedIcon
                            className={classes.blueIcon}
                            onClick={() => {
                              setModal(true);
                              setFilePath(getUrl(file.storageLink));
                              setFileName(middleTruncate(file.name));
                            }}
                          />
                          <DownloadIcon className={classes.blueIcon} onClick={() => {
                            handleLinkDownload(file.id)
                          }} />
                          {action !== Action.VIEW && action !== Action.APPROVE && action !== Action.APPROVE_REJECT_SHOW && (
                            <DeleteOutlineOutlinedIcon
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                setDocumentId(file.id);
                                setIsOpenSweetAlert(true);
                              }}
                            />
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </>

              }
              {loggedInUser?.role?.name !== Role.PROJECT_MANAGER &&
                <div className="col-sm-12 mb-3 mt-3">
                  <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="outlined-basic"
                    label={t("Comment")}
                    name="comment"
                    multiline
                    rows={3}
                    value={formik.values.comment}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    disabled={action !== Action.APPROVE_REJECT_SHOW || status === ProjectDeliverableStatus.APPROVED || status === ProjectDeliverableStatus.REJECTED || action === Action.APPROVE}
                    // onKeyDown={handleKeyDownWeight}
                    required
                  />
                  {formik.touched.comment && formik.errors.comment && (
                    <span className="text-danger">{formik.errors.comment}</span>
                  )}
                </div>
              }
            </div>
          </div>
          {action === Action.SUBMIT && [DeliverableStatus.ONGOING, DeliverableStatus.REJECTED, ProjectDeliverableStatus.DELAYED].includes(
            selectedRow.currentStatus
          ) && (
              <div className="plsubmitButton justify-content-center mt-4">
                <Button
                  onClick={deliverableSubmit}
                  disabled={isLoading || !formik.isValid}
                  className="btn addNew_ProjectBtn"
                >
                  {isLoading && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-1"
                    />
                  )}
                  {t("Submit")}
                </Button>
              </div>
            )}

          {action === Action.APPROVE
            && (
              <div className="plsubmitButton justify-content-center mt-4">
                <Button
                  onClick={async () => {
                    setButtonLoading(true)
                    await handleStatusChange(
                      moduleIdforApproval,
                      actionType,
                      projectIdForApproval,
                      ApprovalStatuses.APPROVED,
                      rowId
                    )
                    setButtonLoading(false)
                  }}
                  className="btn addNew_ProjectBtn"
                >
                  {buttonLoading && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-1"
                    />
                  )}
                  {t("Approve")}
                </Button>
              </div>
            )}

          {action === Action.APPROVE_REJECT_SHOW
            &&
            (
              <div
                className="proSubmissionActions"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                  gap: "7px",
                  paddingTop: "6px",
                }}
              >

                {status ? (
                  status === ProjectDeliverableStatus.APPROVED ? (
                    <Button disabled variant="contained" className="approveBtn" style={{ color: "black", border: "none", textTransform: "none" }}>
                      <DoneIcon className="me-1" />
                      {t("Approved")}
                    </Button>
                  ) : status === ProjectDeliverableStatus.REJECTED ? (
                    <Button disabled variant="contained" color="error" className="rejectBtn" style={{ marginRight: "10px", color: "black", textTransform: "none" }}>
                      <ClearIcon className="me-1" />
                      {t("Rejected")}
                    </Button>
                  ) : (
                    <>
                      <Button
                        disableElevation
                        variant="contained"
                        className="approveBtn"
                        style={{
                          backgroundColor: "#90EE90",
                          color: "black",
                          border: "none",
                          textTransform: "none",
                        }}
                        onClick={async () => {
                          setApprovedButtonLoading(true);
                          await handleStatusChange(
                            moduleIdforApproval,
                            actionType,
                            projectIdForApproval,
                            ApprovalStatuses.APPROVED,
                            rowId
                          );
                          setApprovedButtonLoading(false);
                        }}
                      >
                        {approvedButtonLoading && (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-1"
                          />
                        )}
                        <DoneIcon className="me-1" />
                        {t("Approve")}
                      </Button>

                      <Button
                        disableElevation
                        variant="contained"
                        color="error"
                        className="rejectBtn"
                        onClick={async () => {
                          console.log('moduleIdforApproval from reject button', deliverableId)
                          setRejectButtonLoading(true);
                          // await fetchDeliverableDetails(
                          //   deliverableId,
                          //   projectIdForApproval,
                          //   Action.SUBMIT,
                          //   {
                          //     moduleId: deliverableId,
                          //     actionType: "projectDeliverable",
                          //     projectId: projectIdForApproval,
                          //     approvalId: rowId,
                          //   }
                          // );
                          await deliverableReject()
                          setRejectButtonLoading(false);
                        }}
                        style={{
                          marginRight: "10px",
                          backgroundColor: "#FFC0CB",
                          color: "black",
                          textTransform: "none",
                        }}
                      >
                        {rejectButtonLoading && (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-1"
                          />
                        )}
                        <ClearIcon className="me-1" />
                        {t("Reject")}
                      </Button>
                    </>
                  )
                ) : null}
              </div>
            )
          }
        </form>
      </Drawer>
      {isOpenSweetAlert && (
        <SweetAlert
          title="Are you sure want to delete this document?"
          warning
          showCancel
          confirmButtonText="Yes, delete it!"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => handelDeleteAttachment()}
          onCancel={() => {
            setIsOpenSweetAlert(false)
          }}>
        </SweetAlert>
      )}

      {modal && (
        <DocumentFilePreviewModal modal={modal} setModal={setModal} filePath={filePath} fileName={fileName} />
      )}
    </>
  );
};

export default withTranslation()(SubmitDeliverableDrawer);
